import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "icon-upi",
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ng-template #template>
      <svg
        width="24"
        height="24"
        viewBox="0 0 500 500"
        xmlns="http://www.w3.org/2000/svg"
        [ngClass]="class"
        aria-hidden="true"
      >
        <g>
          <g>
            <path
              fill="#3D3D3C"
              d="M34.513,305.527h3.279l-3.071,12.75c-0.468,1.874-0.364,3.331,0.26,4.268c0.625,0.937,1.769,1.406,3.487,1.406c1.665,0,3.071-0.469,4.163-1.406c1.093-0.937,1.821-2.394,2.29-4.268l3.071-12.75h3.33L48.2,318.589c-0.677,2.81-1.873,4.945-3.643,6.349c-1.717,1.406-4.007,2.135-6.818,2.135c-2.81,0-4.736-0.677-5.776-2.082s-1.249-3.539-0.572-6.349L34.513,305.527z"
            />
            <path
              fill="#3D3D3C"
              d="M50.854,326.499l5.204-21.805l9.888,12.802c0.26,0.364,0.52,0.729,0.781,1.145c0.26,0.416,0.52,0.885,0.833,1.404l3.486-14.519h3.071l-5.204,21.754l-10.096-13.063c-0.26-0.365-0.52-0.729-0.781-1.093c-0.26-0.416-0.468-0.782-0.624-1.25l-3.487,14.572h-3.07V326.499z"
            />
            <path
              fill="#3D3D3C"
              d="M73.856,326.499l4.996-20.973h3.33l-4.996,20.973H73.856z"
            />
            <path
              fill="#3D3D3C"
              d="M81.922,326.499l4.996-20.973h11.397l-0.677,2.915h-8.066l-1.249,5.203h8.066l-0.729,2.967h-8.066l-2.342,9.835h-3.331V326.499z"
            />
            <path
              fill="#3D3D3C"
              d="M97.014,326.499l4.996-20.973h3.33l-4.996,20.973H97.014z"
            />
            <path
              fill="#3D3D3C"
              d="M105.08,326.499l4.996-20.973h11.397l-0.677,2.915h-8.066l-1.249,5.256h8.066l-0.729,2.967h-8.066l-1.613,6.765h8.066l-0.729,3.07H105.08L105.08,326.499z"
            />
            <path
              fill="#3D3D3C"
              d="M120.328,326.499l4.996-20.973h4.476c2.914,0,4.944,0.156,6.036,0.469c1.093,0.313,2.03,0.781,2.758,1.509c0.937,0.937,1.561,2.135,1.821,3.539c0.26,1.458,0.156,3.123-0.26,4.945c-0.469,1.873-1.145,3.486-2.082,4.943c-0.937,1.458-2.134,2.603-3.539,3.539c-1.041,0.729-2.186,1.198-3.435,1.509c-1.197,0.313-3.018,0.469-5.412,0.469h-0.885h-4.476V326.499z M124.387,323.377h2.81c1.509,0,2.706-0.103,3.539-0.311c0.833-0.208,1.561-0.573,2.238-1.042c0.937-0.677,1.717-1.509,2.342-2.549c0.624-0.99,1.093-2.186,1.405-3.539c0.312-1.353,0.416-2.499,0.26-3.486c-0.156-0.99-0.52-1.874-1.145-2.551c-0.468-0.519-1.041-0.832-1.821-1.04c-0.781-0.208-1.977-0.311-3.695-0.311h-1.197h-1.197L124.387,323.377z"
            />
            <path
              fill="#3D3D3C"
              d="M155.455,317.081l-2.238,9.419h-3.122l4.996-20.973h5.048c1.509,0,2.55,0.105,3.227,0.261c0.677,0.156,1.197,0.416,1.613,0.832c0.52,0.469,0.885,1.145,1.041,1.977c0.156,0.834,0.104,1.717-0.104,2.707c-0.26,0.99-0.625,1.925-1.197,2.759c-0.572,0.832-1.249,1.509-1.977,1.978c-0.624,0.364-1.301,0.675-2.029,0.832c-0.729,0.156-1.873,0.261-3.331,0.261h-0.676h-1.249V317.081z M156.34,314.271h0.833c1.821,0,3.122-0.208,3.851-0.626c0.729-0.416,1.197-1.143,1.457-2.186c0.26-1.093,0.104-1.925-0.417-2.341c-0.572-0.469-1.717-0.677-3.434-0.677h-0.833L156.34,314.271z"
            />
            <path
              fill="#3D3D3C"
              d="M177.208,326.499l-1.041-5.411h-8.118l-3.643,5.411h-3.487l15.092-21.805l4.684,21.805H177.208z M170.027,318.226h5.672l-0.937-4.789c-0.052-0.311-0.104-0.677-0.104-1.04c-0.052-0.416-0.052-0.832-0.052-1.301c-0.208,0.469-0.417,0.885-0.677,1.301c-0.208,0.416-0.416,0.782-0.625,1.093L170.027,318.226z"
            />
            <path
              fill="#3D3D3C"
              d="M185.483,326.499l2.29-9.574l-4.163-11.346h3.486l2.602,7.13c0.052,0.208,0.104,0.416,0.208,0.727c0.104,0.313,0.156,0.626,0.26,0.937c0.208-0.311,0.416-0.624,0.624-0.937c0.208-0.311,0.417-0.572,0.625-0.832l6.089-7.025h3.33l-9.731,11.293l-2.29,9.574h-3.33V326.499z"
            />
            <path
              fill="#3D3D3C"
              d="M217.175,316.143c0-0.156,0.052-0.624,0.156-1.353c0.052-0.624,0.104-1.093,0.156-1.509c-0.208,0.469-0.416,0.937-0.677,1.456c-0.26,0.469-0.572,0.99-0.937,1.458l-8.014,11.188l-2.602-11.396c-0.104-0.469-0.208-0.937-0.26-1.353c-0.052-0.416-0.104-0.885-0.104-1.301c-0.104,0.416-0.261,0.885-0.417,1.404c-0.156,0.469-0.364,0.99-0.625,1.511l-4.684,10.304h-3.07l10.044-21.857l2.862,13.218c0.052,0.208,0.104,0.572,0.156,1.04c0.052,0.469,0.156,1.093,0.26,1.822c0.365-0.624,0.833-1.353,1.457-2.29c0.156-0.259,0.312-0.416,0.364-0.572l9.055-13.218l-0.312,21.857h-3.071L217.175,316.143z"
            />
            <path
              fill="#3D3D3C"
              d="M222.692,326.499l4.996-20.973h11.397l-0.676,2.915h-8.066l-1.249,5.256h8.066l-0.728,2.967h-8.066l-1.613,6.765h8.066l-0.729,3.07H222.692L222.692,326.499z"
            />
            <path
              fill="#3D3D3C"
              d="M237.887,326.499l5.204-21.805l9.888,12.802c0.261,0.364,0.521,0.729,0.782,1.145c0.259,0.416,0.519,0.885,0.832,1.404l3.486-14.519h3.07l-5.203,21.754l-10.097-13.063c-0.26-0.365-0.521-0.729-0.781-1.093c-0.26-0.416-0.469-0.782-0.625-1.25l-3.487,14.572h-3.07V326.499z"
            />
            <path
              fill="#3D3D3C"
              d="M271.766,308.389l-4.32,18.058h-3.329l4.319-18.058h-5.411l0.675-2.915h14.155l-0.677,2.915H271.766z"
            />
            <path
              fill="#3D3D3C"
              d="M275.253,322.284l2.967-1.248c0.051,0.937,0.311,1.664,0.885,2.133c0.572,0.469,1.352,0.729,2.394,0.729c0.988,0,1.822-0.26,2.549-0.832c0.729-0.573,1.198-1.301,1.406-2.238c0.311-1.25-0.416-2.343-2.186-3.278c-0.26-0.157-0.416-0.26-0.573-0.313c-1.978-1.145-3.226-2.133-3.747-3.07c-0.519-0.937-0.624-2.03-0.311-3.331c0.416-1.717,1.301-3.07,2.705-4.163c1.406-1.04,2.967-1.614,4.841-1.614c1.509,0,2.705,0.313,3.589,0.885c0.885,0.573,1.353,1.458,1.509,2.551l-2.913,1.353c-0.26-0.677-0.573-1.145-0.99-1.458c-0.416-0.311-0.937-0.469-1.561-0.469c-0.885,0-1.665,0.26-2.289,0.729c-0.626,0.469-1.042,1.093-1.25,1.925c-0.311,1.25,0.574,2.446,2.602,3.539c0.157,0.105,0.261,0.157,0.365,0.208c1.769,0.937,2.965,1.874,3.486,2.811c0.521,0.935,0.624,2.028,0.313,3.434c-0.469,1.978-1.458,3.539-2.967,4.737c-1.509,1.144-3.278,1.769-5.361,1.769c-1.717,0-3.07-0.418-4.007-1.25C275.669,324.99,275.2,323.793,275.253,322.284z"
            />
            <path
              fill="#3D3D3C"
              d="M299.764,326.499l4.995-20.973h3.331l-4.995,20.973H299.764z"
            />
            <path
              fill="#3D3D3C"
              d="M307.882,326.499l5.205-21.805l9.887,12.802c0.26,0.364,0.519,0.729,0.78,1.145c0.26,0.416,0.521,0.885,0.832,1.404l3.488-14.519h3.07l-5.205,21.754l-10.096-13.063c-0.26-0.365-0.521-0.729-0.78-1.093c-0.261-0.416-0.469-0.782-0.626-1.25l-3.486,14.572h-3.07V326.499z"
            />
            <path
              fill="#3D3D3C"
              d="M341.76,308.389l-4.319,18.058h-3.331l4.32-18.058h-5.413l0.677-2.915h14.155l-0.677,2.915H341.76z"
            />
            <path
              fill="#3D3D3C"
              d="M345.351,326.499l4.997-20.973h11.449l-0.677,2.915h-8.067l-1.248,5.256h8.065l-0.727,2.967h-8.067l-1.612,6.765h8.066l-0.729,3.07H345.351L345.351,326.499z"
            />
            <path
              fill="#3D3D3C"
              d="M365.907,317.081l-2.238,9.366h-3.123l4.997-20.973h4.632c1.353,0,2.394,0.105,3.07,0.261c0.727,0.157,1.301,0.469,1.717,0.885c0.521,0.521,0.832,1.145,0.988,1.977c0.157,0.782,0.105,1.666-0.103,2.654c-0.416,1.666-1.093,3.02-2.133,3.955c-1.042,0.937-2.343,1.509-3.904,1.719l4.737,9.522h-3.747l-4.528-9.366H365.907z M366.739,314.426h0.624c1.769,0,2.967-0.208,3.644-0.624c0.677-0.416,1.145-1.145,1.406-2.238c0.259-1.145,0.156-1.978-0.365-2.446c-0.519-0.469-1.614-0.729-3.278-0.729h-0.624L366.739,314.426z"
            />
            <path
              fill="#3D3D3C"
              d="M376.576,326.499l4.995-20.973h11.396l-0.677,2.915h-8.065l-1.248,5.203h8.066l-0.729,2.967h-8.065l-2.341,9.835h-3.331V326.499z"
            />
            <path
              fill="#3D3D3C"
              d="M404.053,326.499l-1.04-5.411h-8.118l-3.644,5.411h-3.486l15.091-21.805l4.684,21.805H404.053z M396.819,318.226h5.672l-0.937-4.789c-0.051-0.311-0.103-0.677-0.103-1.04c-0.052-0.416-0.052-0.832-0.052-1.301c-0.208,0.469-0.416,0.885-0.677,1.301c-0.208,0.416-0.416,0.782-0.624,1.093L396.819,318.226z"
            />
            <path
              fill="#3D3D3C"
              d="M429.188,310.627c-0.729-0.832-1.614-1.456-2.549-1.822c-0.937-0.416-1.978-0.624-3.175-0.624c-2.238,0-4.215,0.729-5.985,2.186c-1.769,1.458-2.915,3.383-3.486,5.724c-0.521,2.238-0.313,4.112,0.729,5.621c0.988,1.456,2.549,2.186,4.632,2.186c1.196,0,2.394-0.208,3.59-0.677c1.198-0.416,2.395-1.093,3.644-1.977l-0.937,3.85c-1.04,0.677-2.133,1.145-3.278,1.458c-1.145,0.311-2.29,0.469-3.539,0.469c-1.561,0-2.967-0.26-4.163-0.781c-1.198-0.519-2.186-1.301-2.967-2.341c-0.78-0.99-1.248-2.186-1.456-3.539c-0.208-1.353-0.156-2.81,0.261-4.371c0.364-1.561,0.988-2.967,1.822-4.32c0.832-1.353,1.925-2.549,3.173-3.539c1.248-1.04,2.602-1.82,4.06-2.341c1.456-0.521,2.913-0.78,4.424-0.78c1.196,0,2.289,0.156,3.331,0.519c0.988,0.365,1.925,0.885,2.757,1.614L429.188,310.627z"
            />
            <path
              fill="#3D3D3C"
              d="M429.501,326.499l4.995-20.973h11.396l-0.677,2.915h-8.066l-1.248,5.256h8.066l-0.729,2.967h-8.065l-1.614,6.765h8.067l-0.729,3.07H429.501z"
            />
          </g>
          <g>
            <g>
              <path
                fill="#70706E"
                d="M368.925,287.261H346.08l31.745-114.645h22.845L368.925,287.261z"
              />
              <path
                fill="#70706E"
                d="M357.06,176.207c-1.561-2.186-4.007-3.279-7.338-3.279H224.201l-6.193,22.481h22.845l0,0h91.332l-6.661,23.991h-91.331v-0.052h-22.846l-18.943,68.434h22.846l12.698-45.9h102.676c3.226,0,6.245-1.093,9.055-3.278c2.81-2.186,4.684-4.892,5.569-8.119l12.697-45.899C358.934,181.151,358.621,178.393,357.06,176.207z"
              />
              <path
                fill="#70706E"
                d="M179.082,280.08c-1.249,4.527-5.412,7.702-10.096,7.702H51.218c-3.226,0-5.62-1.093-7.182-3.278c-1.561-2.187-1.925-4.892-0.989-8.12l28.726-103.456H94.62l-25.656,92.423h91.383l25.656-92.423h22.846L179.082,280.08z"
              />
            </g>
            <g>
              <polygon
                fill="#098041"
                points="440.116,172.824 469,230.277 408.268,287.73"
              />
              <polygon
                fill="#E97626"
                points="419.822,172.824 448.704,230.277 387.92,287.73"
              />
            </g>
          </g>
        </g>
      </svg>
    </ng-template>
  `,
})
export class IconUpiComponent {
  @Input() class: any = "";
  @ViewChild("template", { static: true }) template: any;
  constructor(private readonly viewContainerRef: ViewContainerRef) {}
  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
    this.viewContainerRef.element.nativeElement.remove();
  }
}
